import { useState, useEffect } from 'react'
import { Chart } from '@scuf/charts';
// import { TimeSeries } from '@scuf/charts'
import { Card } from '@scuf/common'
import { useDispatch } from 'react-redux'
import BarData from './BarData'
import BarDataAPI from './BarDataAPI'
import baseServices from '../../../services/base.services';
import { startLineChart } from '../../../actions/entryDataChart'
// import TitlePage from '../../../components/TitlePage/TitlePage';

const Bar = ({ url, body, isCard, titleCard, name }) => {

    const dispatch = useDispatch();
    const [state, setState] = useState([])

    useEffect(() => {


        const getData = async () => {

            try {
                if (body) {
                    var response = await baseServices.getDataN2(body, url);
                    if (response.data && response.data.length > 0) {
                        //dispatch(startLineChart(response.data[0]))                    
                        setState(BarDataAPI(response))
                        setTimeout(() => {
                            getData()
                        }, 150000);

                    }
                } else {
                    setState(BarData())
                    dispatch(startLineChart('dummy data'))
                    setTimeout(() => {
                        getData()
                    }, 150000);
                }

            } catch (err) {
                setTimeout(() => {
                    getData()
                }, 15000);
            }




        }

        getData()

    }, [body, dispatch, url])


    return (
        <>
            {
                isCard === '1' ?
                    <Card className='m-0'>
                        {/* <div className='mayus'>
                            <Card.Header title={titleCard} className='m-0 p-0'></Card.Header>
                        </div> */}
                        <Card.Content style={{ minHeight: '0px' }} className='m-0 p-0'>
                            <Chart height={160} inverted={false} showLegend={false} >
                                <Chart.Title className='m-0' text={titleCard == '' ? state.titulo : titleCard} align='left' />
                                <Chart.YAxis max={100} visible={true} />

                                <Chart.Bar name={name} data={state.datos} pointWidth={8} />
                                <Chart.XAxis categories={state.categories} />

                                {/* <Chart.Bar name="Utilizacion Profit" data={[{ y: 15, color: "#00FF00" }, { y: 50, color: "#FF00FF" }]}/> 
                            <Chart.XAxis  categories={['CH 2°3° - 100%','Espesadores - 50%']}/> */}
                            </Chart>
                        </Card.Content>
                    </Card>
                    :
                    <div>
                        <Chart height={260} inverted={false} showLegend={false} >
                            <Chart.Title className='m-0' text={titleCard == '' ? state.titulo : titleCard} align='left' />
                            <Chart.YAxis showGridLines={false} max={100} visible={true} />

                            <Chart.Bar name={name} data={state.datos} pointWidth={8} borderWidth={0} />
                            <Chart.XAxis categories={state.categories} />

                            {/* <Chart.Bar name="Utilizacion Profit" data={[{ y: 15, color: "#00FF00" }, { y: 50, color: "#FF00FF" }]}/> 
                            <Chart.XAxis  categories={['CH 2°3° - 100%','Espesadores - 50%']}/> */}
                        </Chart>
                    </div>
            }
        </>


    )
}

export default Bar
